import { apiFetch } from "./apiFetch";

export type ModerationAction = "FLAGGED" | "DELETED";

export interface ModerationFlag {
  id: string;
  meetingId: string;
  messageId: string;
  senderId: string;
  senderName: string;
  content: string;
  action: ModerationAction;
  categories: string[];
  confidence: number;
  reason: string;
  createdAt: string;
  meeting?: {
    id: string;
    title: string;
    externalMeetingId: string;
  };
}

export interface Paging {
  count: number;
  total?: number;
  limit: number;
  nextToken?: string | null;
}

export interface ModerationConfig {
  enabled: boolean;
  deleteThreshold: number;
  flagThreshold: number;
  categories?: {
    SEXUAL?: {
      deleteThreshold: number;
      flagThreshold: number;
    };
  };
  timeoutMs: number;
  language: string;
}

export interface DeploymentStatus {
  state:
    | "DEPLOYING"
    | "BAKING"
    | "COMPLETE"
    | "ROLLING_BACK"
    | "ROLLED_BACK"
    | "UNKNOWN";
  deploymentNumber?: number;
  configurationVersion?: string;
  percentageComplete?: number;
  startedAt?: string;
  completedAt?: string;
}

export interface ModerationConfigResponse {
  config: ModerationConfig;
  deployment: DeploymentStatus;
}

export interface BlocklistItem {
  type: "emojis" | "emoticons" | "words";
  value: string;
}

export interface Blocklist {
  emojis: string[];
  emoticons: string[];
  words: string[];
}

export interface Allowlist {
  words: string[];
}

export interface ModerationFlagsResponse {
  data: ModerationFlag[];
  paging: Paging;
}

export const ModerationResource = {
  getFlags: (params?: {
    meetingId?: string;
    action?: ModerationAction;
    limit?: number;
    nextToken?: string;
  }) =>
    apiFetch<ModerationFlagsResponse>("/admin/chat/moderation/flags", {
      searchParams: params,
    }),

  getConfig: () =>
    apiFetch<ModerationConfigResponse>("/admin/chat/moderation/config"),

  updateConfig: (config: ModerationConfig) =>
    apiFetch<ModerationConfig>("/admin/chat/moderation/config", {
      method: "PUT",
      body: config,
    }),

  getBlocklist: () =>
    apiFetch<Blocklist>("/admin/chat/moderation/blocklist"),

  addBlocklistItem: (item: BlocklistItem) =>
    apiFetch<{ success: boolean }>("/admin/chat/moderation/blocklist", {
      method: "POST",
      body: item,
    }),

  deleteBlocklistItem: (item: BlocklistItem) =>
    apiFetch<{ success: boolean }>("/admin/chat/moderation/blocklist", {
      method: "DELETE",
      body: item,
    }),

  getAllowlist: () =>
    apiFetch<Allowlist>("/admin/chat/moderation/allowlist"),

  addAllowlistWord: (value: string) =>
    apiFetch<{ success: boolean }>("/admin/chat/moderation/allowlist", {
      method: "POST",
      body: { value },
    }),

  deleteAllowlistWord: (value: string) =>
    apiFetch<{ success: boolean }>("/admin/chat/moderation/allowlist", {
      method: "DELETE",
      body: { value },
    }),
};
